import { AsanSignActions, AsanVerifyActionTypes, AsanVerifyState } from './types'

const initialState: AsanVerifyState = {
  status: 'idle',
  error: null,
  loading: false,
  data: null,
}

export const AsanVerifyReducer = (
  state = initialState,
  action: AsanSignActions
): AsanVerifyState => {
  switch (action.type) {
    case AsanVerifyActionTypes.FETCH_ASAN_VERIFY_REQUEST:
      return {
        ...state,
        status: 'loading',
        loading: true,
      }
    case AsanVerifyActionTypes.FETCH_ASAN_VERIFY_SUCCESS:
      return {
        ...state,
        status: 'success',
        loading: false,
        data: action.payload,
      }
    case AsanVerifyActionTypes.FETCH_ASAN_VERIFY_FAILED:
      return {
        ...state,
        status: 'failed',
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
